import { render } from "./TwoLevelList.vue?vue&type=template&id=68d5493f&scoped=true"
import script from "./TwoLevelList.vue?vue&type=script&lang=js"
export * from "./TwoLevelList.vue?vue&type=script&lang=js"

import "./TwoLevelList.vue?vue&type=style&index=0&id=68d5493f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d5493f"]])

export default __exports__